import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ClientsWorkOverviewRow } from "../clientsWorkOverviewViewConfig";
import {
    getWorkFinishedState,
    WORK_FINISHED_STATE_TITLES,
} from "../workStageGroups";
import { EMPTY_CELL_VALUE } from "./emptyCellValue";

export const WorkCloseStageCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ClientsWorkOverviewRow,
        string | null
    >) => {
        if (row.original.rowType !== "work") {
            return EMPTY_CELL_VALUE;
        }

        const finishedState = getWorkFinishedState(row.original);
        if (finishedState) {
            return <span>{WORK_FINISHED_STATE_TITLES[finishedState]}</span>;
        }

        return row.original.closeStageName ? (
            <span>{row.original.closeStageName}</span>
        ) : (
            EMPTY_CELL_VALUE
        );
    },
);

WorkCloseStageCell.displayName = "WorkCloseStageCell";
